import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=35f6f2a7&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f6f2a7')) {
      api.createRecord('35f6f2a7', component.options)
    } else {
      api.reload('35f6f2a7', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=35f6f2a7&", function () {
      api.rerender('35f6f2a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/information/edit.vue"
export default component.exports